require('./contractEasyLoanApprovedTypeCStep2.scss');
require('react-pdf/dist/Page/AnnotationLayer.css');

const PropTypes = require('prop-types');
// @ vendor
const React = require('react');
const classnames = require('classnames');
const moment = require('moment');
//@core
const { FormattedText, formatText } = require('core/i18n').i18n;

//@commons
const { OKButton } = require('components/commons/OKButton/OKButton');
const { OKLink } = require('commonsComponents/OKLink');
const OKInformativeListItem = require('components/rebrand/OKInformativeListItem/OKInformativeListItem');
const { OKConsents } = require('gdpr-consents/components/OKConsents/OKConsents.js');
const { GDPRSignaturePattern } = require('components/gdprSignaturePattern/gdprSignaturePattern');
const { OKPdfViewer } = require('commonsComponents/OKPdfViewer');
const { OKMessage } = require('commonsComponents/OKMessage');
// Components
const ContractLoanPdfViewerError = require('../../contractLoanPdfViewerError/contractLoanPdfViewerError');
const { ContractLoanPdfViewer } = require('../../contractLoanPdfViewer/contractLoanPdfViewer');
// @ CC Components
const PreContractualMailInfo = require('components/contactCenter/preContractualMailInfo/preContractualMailInfo');
const BlockInfo = require('components/contactCenter/blockInfo/blockInfo');
const { getPurposeTranslation } = require('components/contactCenter/contracts/contractEasyLoan/contractEasyLoanPurposes');
//@utilities
const { decimalsLength, getFormattedString, formatPercentage, formatNumber, formatAmount } = require('utilities/currencyHelper');
const { es: { DATE_FORMAT_WITH_SLASHES } } = require('commonsConstants/dateFormatTypes');
const PersonalDataHelper = require('utilities/personalDataHelper');
const { openBase64pdfInPrintWindow } = require('utilities/pdfDocumentsHelper');
const download = require('downloadjs');
const { getLastNChars } = require('utilities/stringHelper');
const { isPrintOfficeMode } = require('utilities/contactCenter/printerHelper');
const { 
    recordEasyLoanCApprovedINEClick,
    recordEasyLoanCApprovedDocumentDownload,
    recordEasyLoanCApprovedDocumentPrint, 
    recordEasyLoanCApprovedOTP,
    recordEasyLoanCApprovedNewCode,
    recordEasyLoanCApprovedSignatureKey,
    recordEasyLoanCApprovedDocumentSignature,
} = require('../analytics/contractEasyLoanApprovedTypeC.tracking');
//@constant
const { API_CENTER, API_ENTERPRISE_NUMBER } = require('constants/index');
const { CONTRACT_EASY_LOAN_ID, messages: { OPERATION_EASY_GDPR } } = require('constants/operationTypes');
const {
    amortizationTypes,
    contractEasyLoan,
    CONTRACT_DOCUMENT,
    INE_DOCUMENT,
    CONTRACT_DOCUMENT_NAME,
    INE_DOCUMENT_NAME,
    payrollLoanCommon,
    PRE_APPROVED_DOCUMENT,
    SERVICE_CONTRACT_FOR_PHYSICAL_PERSONS,
    DEFAULT_VIEWER_HEIGHT,
    PDF_VIEWER_SCALE
} = require('../../../../loansConstants/index');
const { HTMLSafeInjector } = require('commonsComponents/htmlSafeInjector');
const { EVIDENCE_EASY_LOAN, NOT_ALLOWED_EVIDENCE_EASY_LOAN_MODELC } = require('constants/flagBasedFeatures');
const translationContractLoanPdfViewerINE = require("../../contractLoanPdfViewerINE/contractLoanPdfViewerINE.translations");

class contractEasyLoanApprovedTypeCStep2 extends React.Component {
    constructor(props) {
        super(props);
        this.handleDownloadINEDocument = this.handleDownloadINEDocument.bind(this);
        this.handleDownloandPDFDocument = this.handleDownloandPDFDocument.bind(this);
        this.handleOnPrintDocument = this.handleOnPrintDocument.bind(this);
        this.handleOnDownloadDocument = this.handleOnDownloadDocument.bind(this);
        this.handleOpenPdfNewTab = this.handleOpenPdfNewTab.bind(this);
        this.handleYesNoSignedDocuments = this.handleYesNoSignedDocuments.bind(this)
        this.handleDocumentReaded = this.handleDocumentReaded.bind(this);
        this.handleDownloadDocument = this.handleDownloadDocument.bind(this);
        this.handleDownloadDocumentOffice = this.handleDownloadDocumentOffice.bind(this);
        this.handlePrintContractOffice = this.handlePrintContractOffice.bind(this);
    }

    handleDocumentReaded() {
         const { checkReadDocument } = this.props;
        checkReadDocument()
    }
    componentWillUnmount() {
        __CONTACT_CENTER__ && this.props.resetPrecontractualMail();
    }

    handleDownloadINEDocument(evt) {
        evt.preventDefault();
        evt.stopPropagation();
        this.props.downloadINEDocument();
    }

    handleDownloandPDFDocument(evt) {
        evt.preventDefault();
        evt.stopPropagation();
        this.props.downloanEasyLoanContractDocument();
    }

    handleOpenPdfNewTab() {
        const { immContractEasyLoanInit } = this.props;
        recordEasyLoanCApprovedINEClick();
        const document = immContractEasyLoanInit.get('fileEasyLoanTypecIneDocument');
        if (document) {
            openBase64pdfInPrintWindow(document, true);
        }
    }

    buildHorizontalList() {
        const { immContractEasyLoanTypeC, immAccounts, immFlagBasedFeatures } = this.props;
        const immOpeningCommission = immContractEasyLoanTypeC.get('openingCommission');
        const openingCommissionAmount = immOpeningCommission.get('amount');
        const percentage = immOpeningCommission.get('percentage');
        const showBothCommissions = immOpeningCommission.get('showPercentajeCommission') && immOpeningCommission.get('showMinCommission');
        const decimalsLengthOpeningCommission = decimalsLength(openingCommissionAmount);
        const openingCommissionPercentage = percentage > 0 ? formatNumber(immOpeningCommission.get('percentage')) : percentage;
        const selectedAccount = immContractEasyLoanTypeC.get('selectedAccount');
        const immAccount = immAccounts.getIn(['byId', selectedAccount]);
        const accountAlias = immAccount.get('alias');
        const accountIban = getLastNChars(immAccount.get('iban'));
        let openingCommissionLabel;

        if (showBothCommissions) {
            const openingCommissionMinAmount = immOpeningCommission.get('minimum');
            const decimalLengthOpeningCommissionMin = decimalsLength(openingCommissionMinAmount);
            const openingCommissionMinFormatted = getFormattedString({
                amount: openingCommissionMinAmount,
                currency: immContractEasyLoanTypeC.get('currency'),
                decimalsLength: decimalLengthOpeningCommissionMin
            });

            openingCommissionLabel = [
                formatText('contractEasyLoanSidebar-openingCommissionWithPercentaje', [openingCommissionPercentage]),
                formatText('contractEasyLoanSidebar-openingCommissionMin', [openingCommissionMinFormatted])
            ];

        } else if (immOpeningCommission.get('showPercentajeCommission')) {
            openingCommissionLabel = formatText('contractEasyLoanSidebar-openingCommissionWithPercentaje', [openingCommissionPercentage]);
        } else {
            openingCommissionLabel = formatText('contractEasyLoanSidebar-openingCommission');
        }

        let fields = [
            {
                text: formatText('contractEasyLoanStepThree-loanImport'),
                value: getFormattedString({
                    amount: immContractEasyLoanTypeC.get('selectedAmount'),
                    currency: immContractEasyLoanTypeC.get('currency'),
                    decimalsLength: 0
                })
            },
            {
                text: formatText('contractEasyLoanStepThree-term'),
                value: formatText('contractEasyLoan-termMonths', [immContractEasyLoanTypeC.get('selectedTerm')])
            },
            {
                text: formatText('contractEasyLoanStepThree-monthlyInstallment'),
                value: getFormattedString(immContractEasyLoanTypeC.get('installment'))
            },
            {
                text: openingCommissionLabel,
                value: getFormattedString({
                    amount: openingCommissionAmount,
                    currency: immContractEasyLoanTypeC.get('currency'),
                    decimalsLength: decimalsLengthOpeningCommission
                }),
                additionalLabel: (<sup>1</sup>),
            },
        ];

        if (__CONTACT_CENTER__ && !isPrintOfficeMode() && immFlagBasedFeatures.get(NOT_ALLOWED_EVIDENCE_EASY_LOAN_MODELC)) {
            const footerList = [
                {
                    text: formatText('contractLoanCompilationCard-TIN'),
                    value: formatPercentage(immContractEasyLoanTypeC.get('tin')),
                },
                {
                    text: formatText('contractLoanCompilationCard-TAE'),
                    value: formatPercentage(immContractEasyLoanTypeC.get('tae'))
                },
                {
                    text: formatText('contractEasyLoanSidebar-associatedAccount'),
                    value: `${accountAlias} ${accountIban}`
                }]
            fields = fields.concat(footerList);
        }

        return fields.map((field, index) => {
            const className = classnames(
                'contract-easy-loan-step-four__horizontal-list-item',
                { 'contract-easy-loan-step-four__horizontal-list-item--first-element': index === 0 },
                { 'contract-easy-loan-step-four__horizontal-list-item--fourth-element': index === 4 }
            );

            return (
                <OKInformativeListItem
                    key={index}
                    title={field.text}
                    additionalLabel={field.additionalLabel}
                    bodyText={field.value}
                    className={className}
                />
            );
        });
    }
    handleYesNoSignedDocuments(value) {
        const { printedAndSignedRadioChanged, enableButtonOffice } = this.props
        printedAndSignedRadioChanged(value)
        enableButtonOffice();
    }
    buildSignaturePatternParams() {
        const { immContractEasyLoanTypeC, immContractEasyLoan, immContractEasyLoanInit, immAccounts, immFlagBasedFeatures } = this.props;
        const selectedAmount = immContractEasyLoanTypeC.get('selectedAmount');
        const currency = immContractEasyLoanTypeC.get('currency');
        const selectedAccount = immContractEasyLoanTypeC.get('selectedAccount');
        const immAccount = immAccounts.getIn(['byId', selectedAccount]);
        const accountProduct = immAccount.get('newProduct');
        const accountContract = immAccount.get('newContractNumber');
        const originAccount = API_ENTERPRISE_NUMBER + API_CENTER + accountProduct + accountContract;
        const propositionYear = immContractEasyLoanTypeC.get('propositionYear');
        const propositionNumber = immContractEasyLoanTypeC.get('propositionNumber');
        const optional1 = API_ENTERPRISE_NUMBER + API_CENTER + propositionYear + propositionNumber;
        const operationProcessIdPolicy = immContractEasyLoan.get('operationProcessIdINE')
       
        return (immFlagBasedFeatures.get(NOT_ALLOWED_EVIDENCE_EASY_LOAN_MODELC) && immFlagBasedFeatures.get(EVIDENCE_EASY_LOAN) && operationProcessIdPolicy) ? {
            ammount: selectedAmount,
            currency,
            optional1,
            originAccount,
            operationProcessId: operationProcessIdPolicy,
            evidenceType: "SIGN_DOCUMENT"
        } : {
            ammount: selectedAmount,
            currency,
            optional1,
            originAccount
        };
    }

    buildSignaturePattern() {
        const { immFlagBasedFeatures } = this.props;
        const operationParams = this.buildSignaturePatternParams();
        const newEasyLoanFF = immFlagBasedFeatures.get(NOT_ALLOWED_EVIDENCE_EASY_LOAN_MODELC)

        return (
            <div>
                <hr />
                <GDPRSignaturePattern
                    operationType={CONTRACT_EASY_LOAN_ID}
                    operationParams={operationParams}
                    multiOTPGDPRMessageCode={OPERATION_EASY_GDPR}
                    isOverDraft={__CONTACT_CENTER__ && isPrintOfficeMode() ? null : newEasyLoanFF}
                    isEasyLoanTypeAB={__CONTACT_CENTER__ && isPrintOfficeMode()}
                    handleSMSClick={recordEasyLoanCApprovedOTP}
                    onResendClick={recordEasyLoanCApprovedNewCode}
                    taggingOnKeyPress={recordEasyLoanCApprovedSignatureKey}
                    taggingOnChangeRadioButton={recordEasyLoanCApprovedDocumentSignature}
                />
            </div>
        )
    }

    handleCheckboxDownloadEvents(event, docType) {
        if (docType === INE_DOCUMENT) {
            this.handleDownloadINEDocument(event);
        } else if (docType === PRE_APPROVED_DOCUMENT) {
            this.handleDownloandPDFDocument(event);
        } else {
            window.open(SERVICE_CONTRACT_FOR_PHYSICAL_PERSONS);
        }
    }

    buildLinkButtonMessage(docType, documentName) {
        return (
            <OKButton
                onClick={event => this.handleCheckboxDownloadEvents(event, docType)}
                modifier="link-emphasize"
                autoHeight
                loading={false}
            >
                {documentName}
            </OKButton>
        )
    }

    buildCheckboxLabel(poeditorPrefix) {
        const getPoEditorKey = key => {
            return `${poeditorPrefix}-${poeditorPrefix}_${key}`;
        };
        const splitMessage = formatText(getPoEditorKey(`contractEasyLoanAgreeCheckboxLabel`)).split('%s');

        const injectedLinks = [
            { docType: INE_DOCUMENT, text: getPoEditorKey('contractEasyLoanIneDocument') },
            { docType: PRE_APPROVED_DOCUMENT, text: getPoEditorKey('contractEasyLoanPreApprovedDocument') },
            { docType: CONTRACT_DOCUMENT, text: getPoEditorKey('contractEasyLoanContractDocument') },
        ];

        const message = splitMessage.map((message, index) => {
            const link = injectedLinks[index];
            const documentName = link ? formatText(link.text) : '';
            const replacement = link ? this.buildLinkButtonMessage(link.docType, documentName) : '';

            return (
                <span key={index}>
                    {message}
                    {replacement}
                </span>
            );
        });

        return <span>{message}</span>;
    }

    handleOnPrintDocument(documentType = "") {
        const { immContractEasyLoanInit, immFlagBasedFeatures, setOfficeStep } = this.props;
        const document = documentType === INE_DOCUMENT ? immContractEasyLoanInit.get('fileEasyLoanIneDocument') : immContractEasyLoanInit.get('fileEasyLoanPolicyDocument');

        if (document) {
            openBase64pdfInPrintWindow(document);
            isPrintOfficeMode() && immFlagBasedFeatures.get(NOT_ALLOWED_EVIDENCE_EASY_LOAN_MODELC) && setOfficeStep("POLICY");
        }
    }

    handleOnDownloadDocument(documentType = "") {
        const { immContractEasyLoanInit } = this.props;
        let documentName = '';
        let document;

        if (documentType === INE_DOCUMENT) {
            document = immContractEasyLoanInit.get('fileEasyLoanIneDocument');
            documentName = INE_DOCUMENT_NAME;
        } else {
            document = immContractEasyLoanInit.get('fileEasyLoanPolicyDocument');
            documentName = CONTRACT_DOCUMENT_NAME;
        }
        download(document, documentName, 'application/pdf');
    }

    buildPdfLink() {
        return (
            <>
                <div>
                    <h4 className="contract-loan-pdf-viewer__subtitle">
                        <strong>
                            <FormattedText value={translationContractLoanPdfViewerINE.SUBTITLE_CONFIRM_PAGE} />
                        </strong>
                    </h4>
                    <div className="contract-actions-readed">
                        <button className="link--red" onClick={this.handleOpenPdfNewTab}>

                            <FormattedText value={translationContractLoanPdfViewerINE.EASY_LOAN_TEXT_CONFIRM_PAGE} />
                        </button>
                        <span><i className="signature-pattern-code-input__icon icon icon-check" />
                            <FormattedText className="signature-text" value={translationContractLoanPdfViewerINE.LEGAL_INFO_READ_BUTTON} />
                        </span>
                    </div>
                    <div className="contract-easy-loan-step-four__informative-text">
                        <FormattedText value={translationContractLoanPdfViewerINE.EASY_LOAN_SUBTITLE_STEP4} />
                    </div>
                </div>

            </>
        )
    }
    
    handleDownloadDocument() {
        const { onDownloadDocument } = this.props;
        const productName = formatText("contractEasyLoanStepThree-contractEasyLoanStepThree_productName");
        recordEasyLoanCApprovedDocumentDownload();
        onDownloadDocument(productName);
    }

    handleDownloadDocumentOffice() {
        const { immContractEasyLoan } = this.props;
        const documentName = INE_DOCUMENT_NAME;
        const document = immContractEasyLoan.get('documents');
        download(document, documentName, 'application/pdf');
        recordEasyLoanCApprovedDocumentDownload();
    }

    handlePrintContractOffice() {
        const { immContractEasyLoan } = this.props;
        const document = immContractEasyLoan.get('documents');
        if (document) {
            openBase64pdfInPrintWindow(document);
        }
    }

    

    buildPdf() {
        const {
            immContractEasyLoanTypeC,
            immContractEasyLoanInit,
            getHiringDocuments,
            toggleAgreeCheckbox,
            immFlagBasedFeatures,
            toggleTypecIneAgreeCheckbox,
            onPrintDocument
        } = this.props;

        const documents = immContractEasyLoanInit.get('fileEasyLoanPolicyDocument');
        const isFetchingPrintDocuments = immContractEasyLoanTypeC.get('isFetchingPrintDocuments');
        const newEasyLoanFF = immFlagBasedFeatures.get(NOT_ALLOWED_EVIDENCE_EASY_LOAN_MODELC);
        const agreeCheckbox = newEasyLoanFF ? immContractEasyLoanTypeC.get('agreeTypeCINECheckbox') : immContractEasyLoanTypeC.get('agreeCheckbox');
        const validate = immContractEasyLoanTypeC.get('showErrorMessage');
        const downloadError = immContractEasyLoanTypeC.get('downloadError');
        const loadingDownload = immContractEasyLoanTypeC.get('isFetchingZip');
        const isLoading = immContractEasyLoanTypeC.get('isFetchingPolicyDocuments');
        const errorLoading = immContractEasyLoanTypeC.get('errorDocuments');

        const poeditorPrefix = 'contractEasyLoanStepThree';
        const title = formatText(`${poeditorPrefix}-${poeditorPrefix}_title`);
        const checkboxLabel = this.buildCheckboxLabel(poeditorPrefix);
        return (
            <>
                <ContractLoanPdfViewer
                    agreeCheckbox={agreeCheckbox}
                    checkboxLabel={checkboxLabel}
                    document={documents}
                    downloadError={downloadError}
                    errorLoading={errorLoading}
                    getDocuments={getHiringDocuments}
                    hasSignaturePattern
                    isCallingDownloadService={isFetchingPrintDocuments}
                    isLoading={isLoading}
                    loadingDownload={loadingDownload}
                    onAgreeCheckbox={newEasyLoanFF ? toggleTypecIneAgreeCheckbox : toggleAgreeCheckbox}
                    onDownload={__CONTACT_CENTER__ && isPrintOfficeMode() ? this.handleDownloadDocumentOffice : this.handleDownloadDocument}
                    onPrint={__CONTACT_CENTER__ && isPrintOfficeMode() ? this.handlePrintContractOffice : onPrintDocument}
                    title={title}
                    validate={validate}
                    viewerHeight={DEFAULT_VIEWER_HEIGHT}
                    checkReadDocumentPolicy={this.handleDocumentReaded}
                    taggingOnPrint={recordEasyLoanCApprovedDocumentPrint}
                />
            </>
        )
    }
    buildLegalDraftContract() {

        const { immContractEasyLoanTypeC, immContractEasyLoanInit, getEasyLoanPolicyDocument, immFlagBasedFeatures } = this.props;
        const errorLoading = immContractEasyLoanTypeC.get('errorEasyLoanContractDocument');
        const newEasyLoanFF = immFlagBasedFeatures.get(NOT_ALLOWED_EVIDENCE_EASY_LOAN_MODELC);
        const agree = isPrintOfficeMode() && newEasyLoanFF ? true : newEasyLoanFF && immContractEasyLoanTypeC.get('agreeIneCheckbox');
        const fileDraftDocument = immContractEasyLoanInit.get('fileEasyLoanPolicyDocument');
        return agree ? (
            <OKPdfViewer
                onDownload={() => this.handleOnDownloadDocument(fileDraftDocument)}
                onPrint={() => this.handleOnPrintDocument(fileDraftDocument)}
                pdfFile={fileDraftDocument}
                title={formatText(translationContractLoanPdfViewerINE.EASY_LOAN_TITLE_CONTRACT_DRAFT_DOCUMENT)}
                scale={PDF_VIEWER_SCALE}
                infiniteScroll
                failedLoadingPdf={errorLoading}
                errorComponent={() => {
                    return <ContractLoanPdfViewerError
                        getDocuments={getEasyLoanPolicyDocument}
                    />
                }}
                viewerHeight={DEFAULT_VIEWER_HEIGHT}
                onDocumentReaded={this.handleDocumentReaded}
            />
        ) : null

    }

    buildPreContractualMailInfo() {
        const {
            immProfile,
            immContractEasyLoanTypeC,
            immAccounts,
            preContractualMail,
            requestProfile,
            sendMail,
            immFlagBasedFeatures,
            getLoanContractDocuments,
            getEasyLoanPolicyDocument,
            sendEasyLoanSimpleEmailApproved
        } = this.props;

        const clientEmail = PersonalDataHelper.getEmail(immProfile);
        const refreshEmailError = immProfile.get('error');
        const indCapson = immContractEasyLoanTypeC.get('indCapson');
        const selectedAccount = immContractEasyLoanTypeC.get('selectedAccount');
        const endOfMonth = immContractEasyLoanTypeC.get('paymentDaySelected') === contractEasyLoan.PAYMENT_DAY_END_OF_MONTH;
        const financedCommission = indCapson === amortizationTypes.YES ? payrollLoanCommon.FINANCIADA : payrollLoanCommon.NO_FINANCIADA;
        const newEasyLoanFF = immFlagBasedFeatures.get(NOT_ALLOWED_EVIDENCE_EASY_LOAN_MODELC);
        const evidenceFF = immFlagBasedFeatures.get(EVIDENCE_EASY_LOAN);
        const mailAPIFlag = immContractEasyLoanTypeC.get('mailAPIFlag');
        const getLoanContractDocument = newEasyLoanFF && evidenceFF ? getLoanContractDocuments : newEasyLoanFF && !evidenceFF ? getEasyLoanPolicyDocument : null;
        const sendMailParams = {
            amount: formatAmount(immContractEasyLoanTypeC.get('selectedAmount')),
            calculatedOpeningCommission: formatAmount(immContractEasyLoanTypeC.getIn(['openingCommission', 'amount'])),
            capitalizedOpeningCommissionIndicator: indCapson,
            clientAccountCode: immAccounts.getIn(['byId', selectedAccount, 'iban']),
            dueDate: moment(immContractEasyLoanTypeC.get('loanDueDate')).format(DATE_FORMAT_WITH_SLASHES),
            endOfMonth,
            financedCommission,
            firstTime: true,
            loanPurpose: getPurposeTranslation(immContractEasyLoanTypeC.get('selectedPurpose')),
            productDuration: immContractEasyLoanTypeC.get('selectedTerm').toString(),
            productType: contractEasyLoan.PRODUCT_TYPE,
            propositionContractNumber: immContractEasyLoanTypeC.get('contractNumber'),
            propositionNumber: immContractEasyLoanTypeC.get('propositionNumber', '').toString(),
            tae: formatAmount(immContractEasyLoanTypeC.get('tae')),
            tin: formatAmount(immContractEasyLoanTypeC.get('tin')),
            year: immContractEasyLoanTypeC.get('propositionYear'),
        };

        return (
            <PreContractualMailInfo
                email={clientEmail}
                preContractualMail={preContractualMail}
                profileError={refreshEmailError}
                requestProfile={requestProfile}
                sendEmail={sendMail}
                sendMailParams={sendMailParams}
                showLegalText={false}
                legalInfoText={newEasyLoanFF ? false : true}
                sendSimpleEmail={sendEasyLoanSimpleEmailApproved}
                mainFlag={'EASY_LOAN'}
                contractObj={immContractEasyLoanTypeC}
                getContractDraftDocument={getLoanContractDocument}
                disableSendButton={newEasyLoanFF ? (!mailAPIFlag || immContractEasyLoanTypeC.get('isEasyLoanEmailInitError')) : false}
                mainFeatureFlag={newEasyLoanFF}
                loadingSendButton={immContractEasyLoanTypeC.get('isFetchingINEDocument')}
            />
        );
    }

    buildContactCenterCheckboxLabel() {
        return (
            <React.Fragment>
                <FormattedText value="contractEasyLoanStepThree-checkboxTextPartOne" />
                <OKButton
                    autoHeight
                    modifier="link-emphasize"
                    onClick={this.handleDownloadINEDocument}
                >
                    <FormattedText value="contractEasyLoanStepThree-checkboxLinkLabelOne" />
                </OKButton>
                <FormattedText value="contractEasyLoanStepThree-checkboxTextPartTwo" />
                <OKButton
                    autoHeight
                    modifier="link-emphasize"
                    onClick={this.handleDownloandPDFDocument}
                >
                    <FormattedText value="contractEasyLoanStepThree-checkboxLinkLabelTwo" />
                </OKButton>
                <FormattedText
                    className="contract-easy-loan-step-four__checkbox-label contract-easy-loan-step-four__checkbox-label--with-left-padding"
                    value="contractEasyLoanStepThree-checkboxTextPartThree"
                />
                <OKLink
                    modifier="emphasize"
                    target="_blank"
                    to={formatText('contractsView-pdfLinkforCPS')}
                >
                    <FormattedText value="contractEasyLoanStepThree-checkboxLinkLabelThree" />
                </OKLink>
                <FormattedText value="contractEasyLoanStepThree-checkboxTextPartFour" />
            </React.Fragment>
        );
    }

    buildQuestion(text) {
        const { immProfile } = this.props;
        const name = PersonalDataHelper.getFullName(immProfile, false);
        const keyName = `<b>${name}</b>`;

        return (<FormattedText value={text} injectedStrings={[keyName]} />);
    }

    buildNameBlock(text) {
        const { immProfile } = this.props;
        const name = PersonalDataHelper.getFullName(immProfile, false);

        return (<BlockInfo><FormattedText value={text} injectedStrings={[name]} /></BlockInfo>);
    }

    buildLegalText(newEasyLoanFF) {
        return (
            newEasyLoanFF ?
                <div className="contract-easy-loan-step-four__informative-text">
                    <OKMessage type="informative">
                        <FormattedText value="contractEasyLoanStepThree-informativeTitle" className="contract-easy-loan-step-four__informativeTitle" /> <br />
                        <FormattedText value="contractEasyLoanStepThree-informativeSubTitle" />
                    </OKMessage>
                </div>
                :
                <div className="no-print-out">
                    <p className="contract-easy-loan-step-four__precontractual-info-mandatory-title">
                        <FormattedText value="contractEasyLoanStepThree-precontractualInfoTitle" />
                    </p>
                    <div className="contract-easy-loan-step-four__precontractual-info-mandatory-reading-section">
                        <div className="contract-easy-loan-step-four__precontractual-info-mandatory-reading-content">
                            <HTMLSafeInjector message={formatText('contractEasyLoanStepThree-precontractualInfoLegalText')} />
                        </div>
                    </div>
                </div>
        );
    }

    buildInformativeText() {
        return (
            <div className="contract-easy-loan-step-four__information">
                <i className="icon-informacion"></i>
                <FormattedText value="preContractualMailInfo-information" ></FormattedText>
            </div>
        );
    }

    buildAcceptLegalText() {
        return (
            <div className="contract-easy-loan-step-four__subtitle">
                <FormattedText value="contractEasyLoanStepThree-legalText"></FormattedText>
            </div>
        );
    }
    buildLealInfo() {
        return (
            <div>
                <h4 className="contract-loan-pdf-viewer__subtitle">
                    <strong>
                        <FormattedText value={translationContractLoanPdfViewerINE.SUBTITLE_CONFIRM_PAGE} />
                    </strong>
                </h4>
                <div className="contract-actions-readed">
                    <strong>
                        <p className="contract-loan-pdf-viewer__subtitle" >
                            <FormattedText value={translationContractLoanPdfViewerINE.EASY_LOAN_TEXT_CONFIRM_PAGE} />
                        </p>
                    </strong>
                    <span><i className="signature-pattern-code-input__icon icon icon-check" />
                        <FormattedText className="signature-text" value={translationContractLoanPdfViewerINE.LEGAL_INFO_READ_BUTTON} />
                    </span>
                </div>
            </div>
        );
    }
    blockInfo() {
        return (
            <BlockInfo>
                <FormattedText value={"contractEasyLoanStepFour-contractBlockTitle"} className="contract-easy-loan-step-four informative-title" /><br />
                <FormattedText value={"contractEasyLoanStepFour-contractBlockSubTitle"} />
            </BlockInfo>
        )
    }
    render() {
        const { immFlagBasedFeatures } = this.props;
        const horizontalList = this.buildHorizontalList();
        const pdfViewer = this.buildPdf()
        const pdfLink = this.buildPdfLink()
         const newEasyLoanFF = immFlagBasedFeatures.get(NOT_ALLOWED_EVIDENCE_EASY_LOAN_MODELC)
        const signaturePattern = this.buildSignaturePattern();
        const confirmationQuestion = this.buildQuestion('confirmationScript-promptMsg')
        const legalText = this.buildLegalText(newEasyLoanFF);;
        const requestPurchaseConfirmation = this.buildNameBlock('contractEasyLoanStepThree-blockInfoSubTitle')

        if (!__CONTACT_CENTER__ && !isPrintOfficeMode()) {
            return (
                <section className="contract-easy-loan-step-four">
                    <div className="contract-easy-loan-step-four__title">
                        <FormattedText value="contractEasyLoanStepThree-title" />
                    </div>
                    <div className="contract-easy-loan-step-four__message">
                        <FormattedText value="contractEasyLoanStepThree-message" />
                    </div>
                    <div>
                        {horizontalList}
                    </div>
                    <div>
                        <OKConsents placementId="purchaseEasyLoan" />
                    </div>
                    {pdfLink}
                    {pdfViewer}
                    {signaturePattern}
                </section>
            );
        }
        if (__CONTACT_CENTER__ && !isPrintOfficeMode()) {

            return (
                <section className="contract-easy-loan-step-four">
                    <div className="contract-easy-loan-step-four__title">
                        <FormattedText value="contractEasyLoanStepThree-title" />
                    </div>
                    <div className="contract-easy-loan-step-four__message">
                        <FormattedText value="contractEasyLoanStepThree-message" />
                    </div>
                    {requestPurchaseConfirmation}
                    <div>
                        {horizontalList}
                    </div>
                    {legalText}
                    <div>
                        <OKConsents placementId="purchaseEasyLoan" />
                    </div>
                    <div className="contract-easy-loan-step-four__checkbox-container">
                        {this.buildLealInfo()}
                    </div>
                    <hr />
                    <div className="contract-easy-loan-step-four__confirmation-question">{confirmationQuestion}</div>
                    {signaturePattern}
                </section>
            );
        }
        if (__CONTACT_CENTER__ && isPrintOfficeMode()) {
            return (
                <section className="contract-easy-loan-step-four">
                    <div className="contract-easy-loan-step-four__title">
                        <FormattedText value="contractEasyLoanStepThree-title" />
                    </div>
                    <div className="contract-easy-loan-step-four__message">
                        <FormattedText value="contractEasyLoanStepThree-message" />
                    </div>
                    <div>
                        {horizontalList}
                    </div>
                    <div>
                        <OKConsents placementId="purchaseEasyLoan" />
                    </div>
                    {pdfLink}
                    {this.blockInfo()}
                    {pdfViewer}

                    {signaturePattern}
                </section>
            );
        }

    }
}

contractEasyLoanApprovedTypeCStep2.propTypes = {
    downloadINEDocument: PropTypes.func.isRequired,
    downloanEasyLoanContractDocument: PropTypes.func.isRequired,
    getHiringDocuments: PropTypes.func.isRequired,
    immFlagBasedFeatures: PropTypes.object.isRequired,
    getINEDocument: PropTypes.func.isRequired,
    getEasyLoanPolicyDocument: PropTypes.func.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immContractEasyLoanTypeC: PropTypes.object.isRequired,
    immProfile: PropTypes.object.isRequired,
    onDownloadDocument: PropTypes.func.isRequired,
    onPrintDocument: PropTypes.func.isRequired,
    preContractualMail: PropTypes.object.isRequired,
    requestProfile: PropTypes.func.isRequired,
    resetPrecontractualMail: PropTypes.func.isRequired,
    sendMail: PropTypes.func.isRequired,
    toggleAgreeCheckbox: PropTypes.func.isRequired,
    setOfficeStep: PropTypes.func,
    getLoanContractDocuments: PropTypes.func,
    sendEasyLoanSimpleEmailApproved: PropTypes.func
};

module.exports = contractEasyLoanApprovedTypeCStep2;